import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const HistogramWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function HistogramWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06383 1C2.65137 1 3.12766 1.47629 3.12766 2.06383V28.8723H29.9362C30.5237 28.8723 31 29.3486 31 29.9362C31 30.5237 30.5237 31 29.9362 31H2.2766C1.57156 31 1 30.4285 1 29.7234V2.06383C1 1.47629 1.47629 1 2.06383 1Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6597 3.32496C30.2022 3.55049 30.4592 4.17313 30.2336 4.71566L29.2513 4.30729C30.2336 4.71566 30.2336 4.71566 30.2336 4.71566L30.2322 4.71906L30.2294 4.72577L30.2197 4.74886L30.1839 4.83226C30.1528 4.90381 30.1076 5.00657 30.0489 5.13588C29.9316 5.39433 29.76 5.75973 29.5402 6.19445C29.1021 7.06074 28.4646 8.21726 27.6744 9.35565C26.8905 10.4848 25.9206 11.6485 24.804 12.4834C23.6861 13.3193 22.3104 13.9037 20.7877 13.6289C18.6991 13.2519 17.8216 11.5115 17.2168 10.3121C17.196 10.2707 17.1755 10.2301 17.1552 10.1901C16.4514 8.79951 16.0048 8.05789 15.0432 7.88435C14.3172 7.75333 13.5343 8.00037 12.679 8.63991C11.8225 9.28034 11.0049 10.2361 10.2822 11.277C9.566 12.3088 8.97798 13.3731 8.56731 14.1851C8.36277 14.5896 8.20409 14.9277 8.09728 15.163C8.04391 15.2806 8.00359 15.3722 7.97708 15.4334L7.94779 15.5016L7.9411 15.5174L7.93983 15.5205C7.71417 16.0628 7.09154 16.3199 6.54913 16.0944C6.0066 15.8689 5.74963 15.2462 5.97517 14.7037L6.9575 15.1121C5.97517 14.7037 5.97517 14.7037 5.97517 14.7037L5.97659 14.7003L5.9794 14.6936L5.98915 14.6705L6.02496 14.5871C6.05597 14.5156 6.1012 14.4128 6.1599 14.2835C6.27723 14.025 6.44879 13.6596 6.66865 13.2249C7.10677 12.3586 7.74417 11.2021 8.53444 10.0637C9.3183 8.93457 10.2882 7.77093 11.4049 6.93595C12.5227 6.10008 13.8984 5.51571 15.4211 5.79052C17.5097 6.16747 18.3872 7.90783 18.992 9.10732C19.0128 9.14863 19.0334 9.18931 19.0536 9.22927C19.7574 10.6199 20.204 11.3615 21.1656 11.535C21.8916 11.666 22.6745 11.419 23.5298 10.7795C24.3863 10.139 25.2039 9.18329 25.9266 8.14233C26.6428 7.11059 27.2308 6.04626 27.6415 5.23423C27.846 4.82979 28.0047 4.49166 28.1115 4.25638C28.1649 4.13881 28.2052 4.04716 28.2317 3.986L28.261 3.91779L28.2677 3.90197L28.269 3.89891C28.4946 3.35662 29.1173 3.09947 29.6597 3.32496Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1915 11.4255C13.604 11.4255 13.1277 11.9018 13.1277 12.4893L13.1277 26.5319C13.1277 27.1194 13.604 27.5957 14.1915 27.5957C14.7791 27.5957 15.2553 27.1194 15.2553 26.5319V12.4893C15.2553 11.9018 14.7791 11.4255 14.1915 11.4255Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.234 12.7021C28.8216 12.7021 29.2978 13.1784 29.2978 13.766V26.5319C29.2978 27.1195 28.8216 27.5957 28.234 27.5957C27.6465 27.5957 27.1702 27.1195 27.1702 26.5319V13.766C27.1702 13.1784 27.6465 12.7021 28.234 12.7021Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2128 16.3192C21.8003 16.3192 22.2766 16.7955 22.2766 17.383L22.2766 26.5319C22.2766 27.1195 21.8003 27.5958 21.2128 27.5958C20.6252 27.5958 20.1489 27.1195 20.1489 26.5319V17.383C20.1489 16.7955 20.6252 16.3192 21.2128 16.3192Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1702 18.4468C7.75774 18.4468 8.23403 18.9231 8.23403 19.5107V26.5319C8.23403 27.1195 7.75774 27.5958 7.1702 27.5958C6.58266 27.5958 6.10637 27.1195 6.10637 26.5319L6.10637 19.5107C6.10637 18.9231 6.58266 18.4468 7.1702 18.4468Z"
        fill="#5137A1"
      />
    </SvgStyled>
  );
});
